export default __webpack_public_path__ + "static/media/biometrics.a0e1d802.svg";